module.exports = __webpack_public_path__ + "static/media/sabia-ilustracao.7bf3f8ea.png";